"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formsyReact = require("formsy-react");

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Input = _interopRequireDefault(require("./Input"));

var _Input2 = _interopRequireDefault(require("./Input.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Input2["default"]);

var ValidatedInput = /*#__PURE__*/function (_Component) {
  _inherits(ValidatedInput, _Component);

  var _super = _createSuper(ValidatedInput);

  function ValidatedInput() {
    var _this;

    _classCallCheck(this, ValidatedInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "mixins", [_react.Mixin]);

    _defineProperty(_assertThisInitialized(_this), "changeValue", function (e) {
      var setValue = _this.props.setValue;
      setValue(e.currentTarget.value);
    });

    return _this;
  }

  _createClass(ValidatedInput, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          getValue = _this$props.getValue,
          getErrorMessage = _this$props.getErrorMessage,
          isPristine = _this$props.isPristine,
          hasValue = _this$props.hasValue,
          attrs = _objectWithoutProperties(_this$props, ["getValue", "getErrorMessage", "isPristine", "hasValue"]);

      var errorMessage = getErrorMessage(); // Adding custom validations - complete API:
      // https://github.com/formsy/formsy-react/blob/master/API.md
      // Validates if a value is included in a list of items
      // ex.: isIn:['apple', 'orange']

      (0, _formsyReact.addValidationRule)('isIn', function (values, value, array) {
        var elements = eval(array); // eslint-disable-line no-eval

        return elements.includes(value);
      }); // Validate if a value is not included in a list of items
      // ex.: isNotIn:['apple', 'orange']

      (0, _formsyReact.addValidationRule)('isNotIn', function (values, value, array) {
        var elements = eval(array); // eslint-disable-line no-eval

        return !elements.includes(value);
      });
      var isValid = !errorMessage && !isPristine() && hasValue();
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: cx('validated-input__wraper')
      }, /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
        extraClasses: cx({
          'is-invalid': errorMessage,
          'is-valid': isValid
        }),
        handleChange: this.changeValue,
        initValue: getValue() || ''
      }, attrs)), /*#__PURE__*/_react["default"].createElement("span", {
        className: cx('input__box-validation-message', 'input__box-validation-message--error', {
          show: errorMessage
        })
      }, errorMessage), /*#__PURE__*/_react["default"].createElement("span", {
        className: cx('input__box-validation-message', 'input__box-validation-message--success', {
          show: isValid
        })
      }, "It looks good!"));
    }
  }]);

  return ValidatedInput;
}(_react.Component);

ValidatedInput.propTypes = _objectSpread({}, _formsyReact.propTypes);

var _default = (0, _formsyReact.withFormsy)(ValidatedInput);

exports["default"] = _default;